import parse from "html-react-parser";


const toHtml = (text: string) => parse(text);

export default toHtml